import { eGameplayState, Gameplay } from "./Gameplay/Gameplay";
import { SpriteDsc, SPRITES } from "./Sprites";
import { AssetLoader } from "./Utils/AssetLoader";
import { RND } from "./Utils/RND";
import { ScaleManager } from "./Utils/ScaleManager";
import { IAudioSprite, AudioManager } from "./Utils/AudioManager";
import * as Gamee from "./Publisher API/Gamee/GameeWrapper";
import * as GameeSDK from "./Publisher API/Gamee/Gamee";
import * as seedrandom from "seedrandom";
import { Sha1 } from "./AsmCrypto/entry-default";
import { PlaneMeshCreator } from "./Utils/Models/PlaneMesh";
import { AmmoLoader } from "./Utils/AmmoLoader";
import { IDictionary } from "./Utils/Collections/Dictionary";
import { ChantingSfxManager } from "./Gameplay/Stadium/ChantingSfx";
import { ProtectedValue } from "./Utils/ProtectedValue";
import { MissionManager } from "./Publisher API/Gamee/MissionManager";



//export const FPS_METER = new FPSMeter(undefined, { graph: 1 });



export const enum eModelAsset {
    ground = "ground",
    grandstand = "grandstand",
    craneCam = "craneCam",
    goalCam = "goalCam",
    goalFrame = "goalFrame",
    goalNet = "goalNet",
    ball = "ball",
    goalie = "goalie",
    character_1 = "char_1",
    character_2 = "char_2",
}



export const enum eAnimAssets {
    goalieIdle = "goalieIdle",
    goalieSideStep = "goalieSideStep",
    goalieCatchDown = "goalieCatchDown_",
    goalieCatchUp = "goalieCatchUp_",
    goalieJumpUp1 = "goalieJumpUp1_",
    goalieJumpUp2 = "goalieJumpUp2_",
    goalieLowSideJump = "goalieLowSideJump_",
    goalieSideJump = "goalieSideJump_",

    playerIdle = "plIdle",
    playerKickOff = "plKickOff",

    defenderIdle = "dfIdle",

    craneCam = "craneCam",
}



export const enum eFontAsset {
    default = "fntDefault",
    arc8UI = "fntArc8UI"
}



export const enum eMaterialAsset {
    atlasWithOpacity = "matAtlas1",
}



export const enum eTextures {
    atlas = "atlas",
    fxAtlas1 = "fx1Atlas",
    textsAtlas = "textsAtlas",
    uiAtlas = "uiAtlas",
    crowdFrames = "crowdAtlas",
    normalBall = "texBallA.png",
    goldenBall = "texBallA.png",
    grandstandOverlay = "grandstandOverlay",
    partSmoke = "partSmoke",

    shooter = "shooter_",
    defender = "defender_",

    banner = "banner",

    manCityLogo = "manCityLogo"
}



export const enum eAtlasFrame {
    kickOffMark = "kickOffMark",
    hitFx = "hitFx/3/",
    flags = "flags/",
    smokeBombGlow = "particles/smokeBomb",
    adBanner = "adBanner",
}



export const enum eUIAtlasFrame {
    aimDot = "aimDot",
    vignetteBL = "vignetteBL",
    vignetteBR = "vignetteBR",
    stBarBg = "statusBar/hudBg",
    lifeBarBg = "statusBar/lifeBarBg",
    lifeBarBallIcon = "statusBar/ballIcon",
    fireBallBarBg = "statusBar/fireBallBarBg",
    fireBallBarIcon = "statusBar/fireBallBarIcon_",
    fireBallBarFlames = "statusBar/fireBallBarFlames_",
    fireBallBarFill = "statusBar/fireBallBarFill",
    resWnd = "results/wnd",
    resBtnOK = "results/btnClose_",
    tutHand = "tutorial/hand"
}



export const enum eAtlas {
    def1,
    fx1,
    texts,
    ui
}



export const SfxSprites: IDictionary<IAudioSprite> = {
    "bonus": {
        "start": 0,
        "end": 1.2725170068027212,
        "loop": false
    },
    "bullsEye": {
        "start": 3,
        "end": 4.6794784580498865,
        "loop": false
    },
    "catch_0": {
        "start": 6,
        "end": 6.453628117913832,
        "loop": false
    },
    "catch_1": {
        "start": 8,
        "end": 8.362222222222222,
        "loop": false
    },
    "fireballOn": {
        "start": 10,
        "end": 12.46374149659864,
        "loop": false
    },
    "goal_0": {
        "start": 14,
        "end": 18.54283446712018,
        "loop": false
    },
    "goal_1": {
        "start": 20,
        "end": 24.538049886621316,
        "loop": false
    },
    "kick_0": {
        "start": 26,
        "end": 26.11126984126984,
        "loop": false
    },
    "kick_1": {
        "start": 28,
        "end": 28.11374149659864,
        "loop": false
    },
    "kick_2": {
        "start": 30,
        "end": 30.105034013605444,
        "loop": false
    },
    "miss_0": {
        "start": 32,
        "end": 36.259909297052154,
        "loop": false
    },
    "miss_1": {
        "start": 38,
        "end": 42.40403628117914,
        "loop": false
    },
    "miss_2": {
        "start": 44,
        "end": 48.540566893424035,
        "loop": false
    },
    "postHit": {
        "start": 50,
        "end": 50.58575963718821,
        "loop": false
    },
    "targetHit": {
        "start": 52,
        "end": 53.51596371882086,
        "loop": false
    },
    "timeTick": {
        "start": 55,
        "end": 55.194648526077096,
        "loop": false
    },
    "whistle": {
        "start": 57,
        "end": 57.27024943310658,
        "loop": false
    }
}



export const enum eAudioAsset {
    sfx = "sfx",
    stadiumLoop = "stadiumLoop",
    chantLoop = "chanting_",
}



export const enum eSfxSprite {
    bonus = "bonus",
    bullsEye = "bullsEye",
    catch = "catch_",
    fireballOn = "fireballOn",
    goal = "goal_",
    kick = "kick_",
    miss = "miss_",
    postHit = "postHit",
    targetHit = "targetHit",
    timeTick = "timeTick",
    whistle = "whistle"
}



export const enum eManulSortLayerDrawOrder {
    flashFx = 0,
    flags = 1,
    grandstandOverlay = 10,
    targetTrajectory = 99,
    target = 100,
    targetShards = 150,
    targetHitFx = 200,
    ballFireBallGlow = 300,
    ballTail = 301,
}



/**
 * Global random number generator
 */
const DEF_RND_SEED = Date.now();


export const rnd1 = new RND(DEF_RND_SEED.toString());
export const rnd2 = new RND(DEF_RND_SEED.toString());


export const enum ePublisherAPI {
    NONE,
    ARC8,
    PRIZES
}



export class GameSettings {
    /**
     * (RO) Casovy limit na hru v ms. Pokud <= 0, tak cas neni omezen
     */
    get timeLimit(): number { return this._timeLimit.value; }
    private _timeLimit: ProtectedValue;
    /**
     * (RO) Penalizace za extra pauzy
     */
    get pausePenalty(): number { return this._pausePenalty.value; }
    private _pausePenalty: ProtectedValue;
    /**
     * (RO) Pocet pauz, za ktere hrac nedostane penalizaci
     * Pokud < 0, tak pocet pauz neni omezen
     */
    get freePauseCnt(): number { return this._freePauseCnt.value; }
    private _freePauseCnt: ProtectedValue;
    /**
     * (RO) Pocet micu na hru
     */
    get ballCnt(): number { return this._ballCnt.value; }
    private _ballCnt: ProtectedValue;
    /**
     * (RO) True, pokud se ma zobrazovat tutorial
     */
    get tutorial(): boolean { return this._tutorial; }
    private _tutorial: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(timeLimit: number, ballCnt: number, pausePenalty: number, tutorial: boolean, freePauseCnt: number = -1) {
        this._timeLimit = new ProtectedValue(timeLimit * 1000);
        this._ballCnt = new ProtectedValue(ballCnt);
        this._pausePenalty = new ProtectedValue(pausePenalty);
        this._freePauseCnt = new ProtectedValue(freePauseCnt);
        this._tutorial = tutorial;
    }
}



export class Game {
    static readonly GRAVITY_Y = -9.81 * 0.8;

    /**
     * (RO) pc.Application
     */
    static get app(): pc.Application { return Game._app; }
    private static _app: pc.Application;

    /**
     * Typ API, ktere hra pouziva
     */
    static API = ePublisherAPI.PRIZES;

    static get settings(): GameSettings { return Game._settings[Game.API]; }
    private static _settings: GameSettings[] = [
        // None
        new GameSettings(180, 3, 0, true),
        // Arc8
        undefined,
        // Prizes
        new GameSettings(0, 3, 0, true, 0)
    ];

    /**
     * (RO) True, pokud je hra pozastavena
     */
    static get paused(): boolean { return Game._paused; }
    private static _paused: boolean = false;
    /**
     * (RO) Scale manager
     */
    static get scale(): ScaleManager { return this._scale; }
    private static _scale: ScaleManager

    private static _atlas: pc.TextureAtlas[];

    static get atlas(): pc.TextureAtlas { return Game._atlas[eAtlas.def1]; }
    /**
     * Seed pro generator nahodnych cisel, ktery ridi gameplay
     */
    static get seed(): number { return Game._seed.value; }
    private static _seed: ProtectedValue;
    /**
     * Spravce audia
     */
    static get audio(): AudioManager { return Game._audio; }
    private static _audio: AudioManager;

    private static _loader: AssetLoader;

    private static readonly _FLAG_SDK_INITIALIZED = 0x0001;
    private static readonly _FLAG_ASSETS_LOADED = 0x0002;

    private _flags: number;

    private _gameplay: Gameplay;

    /**
     * (RO) Prizes mise
     */
    static get missions(): MissionManager { return Game._missions; }
    private static _missions: MissionManager;

    static get canvas(): HTMLCanvasElement { return Game._canvas; }
    private static _canvas: HTMLCanvasElement;

    /**
     * FOV kamery pri minimalni vysce rozliseni
     */
    private static readonly CAM_MIN_H_FOV = 45;
    /**
     * FOV kamery pri maximalni vysce rozliseni
     */
    private static readonly CAM_MAX_H_FOV = 48;

    static get camera(): pc.Entity { return Game._camera; }
    private static _camera: pc.Entity;

    static get manualSortLayer(): pc.Layer { return this._manualSortLayer; }
    private static _manualSortLayer: pc.Layer;

    static get planeMeshCreator(): PlaneMeshCreator { return Game._planeMeshCreator; }
    private static _planeMeshCreator: PlaneMeshCreator;

    private static _ambientSoundIns: pc.SoundInstance;

    private static _sha: Sha1;
    private static _textEncoder: TextEncoder;
    private static _hashPhrase: string;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        //Game._startTime = Date.now();
        this._flags = 0;
        Game._seed = new ProtectedValue(DEF_RND_SEED);

        // SHA
        if (Game.API == ePublisherAPI.ARC8) {
            Game._sha = new Sha1();
            Game._textEncoder = new TextEncoder();
        }

        // Nacist Ammo knihovnu
        AmmoLoader.loadAmmoAsync(this.handleAmmoLoadComplete, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static calculateHash(input: string): string {
        let data = Game._textEncoder.encode(input + this._hashPhrase);

        Game._sha.reset();
        Game._sha.process(data);
        Game._sha.finish();

        // convert ArrayBuffer to Array
        const hashArray = Array.from(Game._sha.result);

        // convert bytes to hex string                  
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static getAtlas(atlas: eAtlas): pc.TextureAtlas { return this._atlas[atlas]; }

    //-------------------------------------------------------------------------
    /**
     * Vrati pc.Batch pro id batch skupiny nebo undefined, pokud pc.Batch pro danou skupinu neexistuje
     * @param groupId 
     * @param from 
     */
    //-------------------------------------------------------------------------
    static getBatch(groupId: number, from?: number): pc.Batch {
        let batches = (<any>Game.app.batcher)._batchList as pc.Batch[];
        let batchId = (from == undefined ? batches.length : from);

        while (batchId-- != 0) {
            if (batches[batchId].batchGroupId == groupId) {
                return batches[batchId];
            }
        }

        return undefined;
    }

    //-------------------------------------------------------------------------
    /**
     * Prehrat zvuk
     * @param slotName 
     */
    //-------------------------------------------------------------------------
    static playSound(slotName: eSfxSprite | string): void {
        Game._audio.playSound(Game._app.root, slotName);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static stopAllSounds(): void {
        Game._audio.stop();
        //HUD.instance.debugOutput.addEntry("STOP ALL SOUNDS: " + Game.getCurTimeFromStart());
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static startAmbientAudio(): void {
        /*let debug = HUD.instance.debugOutput;

        if (this._ambientSoundIns) {
            debug.addEntry("SOUND INSTANCE EXISTS");
            debug.addEntry("PL: " + (this._ambientSoundIns.isPlaying ? "1" : "0") +
                " PAU: " + (this._ambientSoundIns.isPaused ? "1" : "0") +
                " STOP: " + (this._ambientSoundIns.isStopped ? "1" : "0") +
                " SUS: " + (this._ambientSoundIns.isSuspended ? "1" : "0"));
        }
        else {
            debug.addEntry("NO SOUND INSTANCE");
        }*/

        if (!Game._audio.isMuted && !Game._paused && Gameplay.instance.state <= eGameplayState.intro) {
            // Hlavni zvukova smycka
            if (!Game._app.root.sound.slots[eAudioAsset.stadiumLoop]) {
                Game._app.root.sound.addSlot(eAudioAsset.stadiumLoop, {
                    loop: true,
                    autoPlay: false,
                    volume: 0.75,
                    overlap: false,
                    asset: Game._app.assets.find(eAudioAsset.stadiumLoop, pc.eAssetType.audio).id
                });

                //debug.addEntry("ADDED AMBIENT AUDIO SLOT")
            }

            if (!this._ambientSoundIns) {
                this._ambientSoundIns = Game._audio.playSound(Game._app.root, eAudioAsset.stadiumLoop);
                //debug.addEntry("NEW SOUND INSTANCE: " + Game.getCurTimeFromStart());
            }
            else if (this._ambientSoundIns.isStopped) {
                this._ambientSoundIns.play();
            }
        }
    }

    /*private static _startTime: number;

    private static getCurTimeFromStart(): number {
        return Date.now() - Game._startTime;
    }*/
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAmmoLoadComplete(): void {
        // Ziskat canvas
        let canvas = Game._canvas = document.getElementById("renderCanvas") as HTMLCanvasElement;

        // Vytvorit pc.Application
        Game._app = new pc.Application(canvas, {
            elementInput: new pc.ElementInput(canvas), graphicsDeviceOptions: { alpha: false }
        });

        if (pc.platform.touch) {
            Game._app.touch = new pc.TouchDevice(canvas);
        }
        else {
            Game._app.mouse = new pc.Mouse(canvas);
        }

        Game._app.setCanvasFillMode(pc.FILLMODE_NONE);
        Game._app.addTweenManager();
        Game._app.start();

        // Ministats
        /*const options = MiniStats.getDefaultOptions();

        // number of materials used in a frame
        options.stats = [
            // frames per second
            {
                name: "FPS",
                stats: ["frame.fps"],
                watermark: 60,
            },
            // total number of draw calls
            {
                name: "DrawCalls",
                stats: ["drawCalls.total"],
                watermark: 2000,
            },
        ];

        const miniStats = new MiniStats(Game._app, options);*/

        // Audio
        Game._audio = new AudioManager();

        // Plane Mesh Createor
        Game._planeMeshCreator = new PlaneMeshCreator();

        // Nastavit gravitaci
        (<any>Game._app.systems).rigidbody.gravity.set(0, Game.GRAVITY_Y, 0);
        (<any>Game._app.systems).rigidbody.fixedTimeStep = 1 / 120;

        // Scaling
        Game._scale = new ScaleManager(Game._app, new pc.Vec2(640, 840), new pc.Vec2(640, 1600));
        Game._scale.resize();

        // Manualne razena vrstva vykreslujici se nad "World" vrstvou
        Game._manualSortLayer = new pc.Layer({
            name: "ManualSortLayer",
            transparentSortMode: pc.SORTMODE_MANUAL,
        });

        const layers = Game._app.scene.layers;

        layers.insertTransparent(Game._manualSortLayer, layers.getTransparentIndex(layers.getLayerByName("World")) + 1);

        // Kamera
        Game._camera = new pc.Entity("camera");
        Game._camera.addComponent(pc.eCompomentType.camera, {
            clearColor: new pc.Color(0, 0, 0),
            nearClip: 0.1,
            fov: 45,
            frustumCulling: false
        });
        Game._app.root.addChild(Game._camera);

        let layerList = [...Game._camera.camera.layers];

        layerList.push(Game._manualSortLayer.id);
        Game._camera.camera.layers = layerList;

        // Inicializace publisher API
        this.initPublisherAPI();

        // Loader
        Game._app.assets.on(AssetLoader.EVENT_LOADED, this.handleLoaderComplete, this);
        Game._loader = new AssetLoader(Game._app.assets, "assets/");

        // Modely
        Game._loader.addAsset(eModelAsset.ground, pc.eAssetType.model, "models/ground.glb");
        Game._loader.addAsset(eModelAsset.grandstand, pc.eAssetType.model, "models/grandstand.glb");
        Game._loader.addAsset(eModelAsset.goalCam, pc.eAssetType.model, "models/goalCam.glb");
        Game._loader.addAsset(eModelAsset.goalFrame, pc.eAssetType.model, "models/goalFrame.glb");
        Game._loader.addAsset(eModelAsset.goalNet, pc.eAssetType.model, "models/goalNet.glb");
        Game._loader.addAsset(eModelAsset.ball, pc.eAssetType.model, "models/ball.glb");
        Game._loader.addAsset(eModelAsset.goalie, pc.eAssetType.model, "models/goalie.glb");
        Game._loader.addAsset(eModelAsset.character_1, pc.eAssetType.model, "models/shooter_1.glb");
        Game._loader.addAsset(eModelAsset.character_2, pc.eAssetType.model, "models/shooter_2.glb");
        Game._loader.addAsset(eModelAsset.craneCam, pc.eAssetType.model, "models/craneCam.glb");

        // Animace
        Game._loader.addAsset(eAnimAssets.goalieIdle, pc.eAssetType.animation, "anims/goalie/idle.glb");
        Game._loader.addAsset(eAnimAssets.goalieSideStep, pc.eAssetType.animation, "anims/goalie/sideStep.glb");
        Game._loader.addAsset(eAnimAssets.goalieCatchDown + "L", pc.eAssetType.animation, "anims/goalie/catchDownL.glb");
        Game._loader.addAsset(eAnimAssets.goalieCatchDown + "R", pc.eAssetType.animation, "anims/goalie/catchDownR.glb");
        Game._loader.addAsset(eAnimAssets.goalieCatchUp + "L", pc.eAssetType.animation, "anims/goalie/catchUpL.glb");
        Game._loader.addAsset(eAnimAssets.goalieCatchUp + "R", pc.eAssetType.animation, "anims/goalie/catchUpR.glb");
        Game._loader.addAsset(eAnimAssets.goalieJumpUp1 + "L", pc.eAssetType.animation, "anims/goalie/jumpUp1L.glb");
        Game._loader.addAsset(eAnimAssets.goalieJumpUp1 + "R", pc.eAssetType.animation, "anims/goalie/jumpUp1R.glb");
        Game._loader.addAsset(eAnimAssets.goalieJumpUp2 + "L", pc.eAssetType.animation, "anims/goalie/jumpUp2L.glb");
        Game._loader.addAsset(eAnimAssets.goalieJumpUp2 + "R", pc.eAssetType.animation, "anims/goalie/jumpUp2R.glb");
        Game._loader.addAsset(eAnimAssets.goalieLowSideJump + "L", pc.eAssetType.animation, "anims/goalie/lowSideJumpL.glb");
        Game._loader.addAsset(eAnimAssets.goalieLowSideJump + "R", pc.eAssetType.animation, "anims/goalie/lowSideJumpR.glb");
        Game._loader.addAsset(eAnimAssets.goalieSideJump + "L", pc.eAssetType.animation, "anims/goalie/sideJumpL.glb");
        Game._loader.addAsset(eAnimAssets.goalieSideJump + "R", pc.eAssetType.animation, "anims/goalie/sideJumpR.glb");
        Game._loader.addAsset(eAnimAssets.playerIdle, pc.eAssetType.animation, "anims/shooter/idle.glb");
        Game._loader.addAsset(eAnimAssets.playerKickOff, pc.eAssetType.animation, "anims/shooter/kickOff.glb");
        Game._loader.addAsset(eAnimAssets.defenderIdle, pc.eAssetType.animation, "anims/defender/idle.glb");
        Game._loader.addAsset(eAnimAssets.craneCam, pc.eAssetType.animation, "anims/craneCamAnim.glb");

        // Textury
        Game._loader.addAsset(eTextures.banner, pc.eAssetType.texture, "textures/banner.jpg");
        Game._loader.addAsset(eTextures.atlas, pc.eAssetType.texture, "textures/atlas.png");
        Game._loader.addAsset(eTextures.atlas, pc.eAssetType.atlas, "textures/atlas.json");
        Game._loader.addAsset(eTextures.fxAtlas1, pc.eAssetType.texture, "textures/atlasFx_0.png");
        Game._loader.addAsset(eTextures.fxAtlas1, pc.eAssetType.atlas, "textures/atlasFx_0.json");
        Game._loader.addAsset(eTextures.textsAtlas, pc.eAssetType.texture, "textures/atlasTexts_0.png");
        Game._loader.addAsset(eTextures.textsAtlas, pc.eAssetType.atlas, "textures/atlasTexts_0.json");

        Game._loader.addAsset(eTextures.uiAtlas, pc.eAssetType.texture, "textures/atlasUI.png");
        Game._loader.addAsset(eTextures.uiAtlas, pc.eAssetType.atlas, "textures/atlasUI.json");
        Game._loader.addAsset(eTextures.crowdFrames, pc.eAssetType.texture, "textures/crowd.jpg");
        Game._loader.addAsset(eTextures.grandstandOverlay, pc.eAssetType.texture, "textures/grandstandOverlay.png");
        Game._loader.addAsset(eTextures.partSmoke, pc.eAssetType.texture, "textures/partSmoke.png");
        Game._loader.addAsset(eTextures.manCityLogo, pc.eAssetType.texture, "textures/manCityLogo.png");

        for (let i = 0; i < 2; i++) {
            Game._loader.addAsset(eTextures.shooter + (i + 1), pc.eAssetType.texture, "textures/shooter_" + (i + 1) + ".jpg");
            Game._loader.addAsset(eTextures.defender + i, pc.eAssetType.texture, "textures/defender_" + i + ".jpg");
        }

        // Fonty
        Game._loader.addAsset(eFontAsset.default, pc.eAssetType.font, "fonts/default.json");
        Game._loader.addAsset(eFontAsset.arc8UI, pc.eAssetType.font, "fonts/arc8UI.json");

        // Audio
        Game._loader.addAsset(eAudioAsset.sfx, pc.eAssetType.audio, "audio/sfx.mp3");
        Game._loader.addAsset(eAudioAsset.stadiumLoop, pc.eAssetType.audio, "audio/stadiumLoop.mp3");

        for (let i = 0; i < ChantingSfxManager.SFX_VER_CNT; i++)
            Game._loader.addAsset(eAudioAsset.chantLoop + i, pc.eAssetType.audio, "audio/chanting_" + i + ".mp3");

        Game._loader.load();

        // Zachytavat zmenu rozliseni
        Game._app.on(ScaleManager.EVENT_RESIZE, this.handleGameResize, this);
        this.handleGameResize(Game._scale.width, Game._scale.height);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private initPublisherAPI(): void {
        // Publisher API
        if (Game.API == ePublisherAPI.ARC8 || Game.API == ePublisherAPI.PRIZES) {
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.start, () => { Game._paused = false; Game._app.timeScale = 1; });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.pause, () => { Game.stopAllSounds(); Game._paused = true; Game._app.timeScale = 0; });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.resume, () => { Game._paused = false; Game._app.timeScale = 1; Game.startAmbientAudio(); });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.mute, () => { Game.stopAllSounds(); Game._audio.isMuted = true; });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.unmute, () => { Game._audio.isMuted = false; Game.startAmbientAudio(); });
            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.submit, () => { Game._paused = false; Game._app.timeScale = 1; });

            Gamee.Wrapper.gameInit(Game.API == ePublisherAPI.PRIZES ? [GameeSDK.eCapability.extraLife, GameeSDK.eCapability.missions] : [], () => {
                let timeLimit = 180;
                let pausePenalty = -1;
                let showTutorial = true;

                if (Gamee.Wrapper.INIT_DATA) {
                    let initData = Gamee.Wrapper.INIT_DATA;

                    // Povolit/zakazat zvuk
                    Game._audio.isMuted = !initData.sound;

                    if (Game.API == ePublisherAPI.PRIZES) {
                        // Mise
                        Game._missions = new MissionManager();

                        if (initData.missionData) {
                            let missionData = (typeof initData.missionData == "string" ? JSON.parse(initData.missionData) : initData.missionData);
                            let targetVal = 0;

                            if (missionData.value)
                                targetVal = <number>(typeof missionData.value == "string" ? parseInt(missionData.value) : missionData.value);

                            Game._missions.setActiveMission(missionData.id, targetVal);
                        }
                    }
                    else if (initData.initData) {
                        let data: GameeSDK.IArc8InitData;

                        if (typeof initData.initData == "string") {
                            data = JSON.parse(initData.initData);
                            initData.initData = data;
                        }
                        else {
                            data = initData.initData;
                        }

                        // Seed
                        if (data.seed == undefined)
                            throw new Error("GAMEE: missing seed for random number generator");

                        rnd1.rnd = seedrandom((Game._seed.value = data.seed).toString());

                        // TimeLimit
                        timeLimit = data.playTime;

                        if (timeLimit == undefined)
                            throw new Error("GAMEE: missing 'playTime'");

                        timeLimit /= 1000;

                        // Penalizace za pauzy
                        pausePenalty = data.pauseScorePenalization;

                        if (pausePenalty == undefined)
                            throw new Error("GAMEE: missing 'pauseScorePenalization'");

                        showTutorial = data.gameAlreadyPlayed == false;

                        // Slozit secret frazi pro updateScore
                        Game._hashPhrase = ":" + Game._seed + ":3?Kh9A!m6A+zRE0";
                    }
                }

                if (Game.API == ePublisherAPI.ARC8)
                    Game._settings[ePublisherAPI.ARC8] = new GameSettings(timeLimit, 3, pausePenalty, true, 3);

                this.handleInitProgress(Game._FLAG_SDK_INITIALIZED);
            }, this);
        }
        else {
            this._flags = Game._FLAG_SDK_INITIALIZED;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleLoaderComplete(): void {
        Game._atlas = [];
        Game._atlas[eAtlas.def1] = Game._app.assets.find(eTextures.atlas, pc.eAssetType.atlas).resource as pc.TextureAtlas;
        Game._atlas[eAtlas.fx1] = Game._app.assets.find(eTextures.fxAtlas1, pc.eAssetType.atlas).resource as pc.TextureAtlas;
        Game._atlas[eAtlas.texts] = Game._app.assets.find(eTextures.textsAtlas, pc.eAssetType.atlas).resource as pc.TextureAtlas;
        Game._atlas[eAtlas.texts].texture.mipmaps = false;
        Game._atlas[eAtlas.ui] = Game._app.assets.find(eTextures.uiAtlas, pc.eAssetType.atlas).resource as pc.TextureAtlas;
        Game._atlas[eAtlas.ui].texture.mipmaps = false;

        (Game._app.assets.find(eTextures.manCityLogo, pc.eAssetType.texture).resource as pc.Texture).mipmaps = false;
        //(Game._app.assets.find(eTextures.crowdAtlas, pc.eAssetType.texture).resource as pc.Texture).mipmaps = false;

        // Audio
        let sfxAssetId = Game.app.assets.find(eAudioAsset.sfx, pc.eAssetType.audio).id;
        let audioEnt = Game._app.root;

        Game._audio.createSoundComponent(audioEnt);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.bonus, SfxSprites[eSfxSprite.bonus], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.bullsEye, SfxSprites[eSfxSprite.bullsEye], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.catch + "0", SfxSprites[eSfxSprite.catch + "0"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.catch + "1", SfxSprites[eSfxSprite.catch + "1"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.fireballOn, SfxSprites[eSfxSprite.fireballOn], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.goal + "0", SfxSprites[eSfxSprite.goal + "0"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.goal + "1", SfxSprites[eSfxSprite.goal + "1"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.kick + "0", SfxSprites[eSfxSprite.kick + "0"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.kick + "1", SfxSprites[eSfxSprite.kick + "1"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.kick + "2", SfxSprites[eSfxSprite.kick + "2"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.miss + "0", SfxSprites[eSfxSprite.miss + "0"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.miss + "1", SfxSprites[eSfxSprite.miss + "1"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.miss + "2", SfxSprites[eSfxSprite.miss + "2"], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.postHit, SfxSprites[eSfxSprite.postHit], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.targetHit, SfxSprites[eSfxSprite.targetHit], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.timeTick, SfxSprites[eSfxSprite.timeTick], sfxAssetId);
        Game._audio.addSoundSlot(audioEnt, eSfxSprite.whistle, SfxSprites[eSfxSprite.whistle], sfxAssetId);

        // Nastavit Anisotropy pro grass
        (Game._app.assets.find("texGrass.jpg", pc.eAssetType.texture).resource as pc.Texture).anisotropy = 2;

        // Material s opacity, ktery pouziva jako atlas texturu
        let mat = new pc.StandardMaterial();

        mat.diffuseMap = Game._atlas[0].texture;
        mat.blendType = pc.BLEND_NORMAL;
        mat.opacity = 0.99;
        mat.opacityMap = Game._atlas[0].texture;
        mat.opacityMapChannel = "a";
        mat.update();

        let asset = new pc.Asset(eMaterialAsset.atlasWithOpacity, pc.eAssetType.material, { url: "" });
        asset.loaded = true;
        asset.resource = mat;
        Game._app.assets.add(asset);

        // Sprity
        SPRITES.forEach((data: SpriteDsc) => {
            let sprite = new pc.Sprite(Game._app.graphicsDevice, {
                atlas: Game._atlas[data.atlas],
                frameKeys: data.frameKeys,
                pixelsPerUnit: data.pixelsPerUnit,
                renderMode: pc.SPRITE_RENDERMODE_SIMPLE
            });

            asset = new pc.Asset(data.name, pc.eAssetType.sprite, { url: "" });
            asset.resource = sprite;
            asset.loaded = true;
            Game._app.assets.add(asset);
        });

        this.handleInitProgress(Game._FLAG_ASSETS_LOADED);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleInitProgress(progressFlag: number): void {
        this._flags |= progressFlag;

        if ((this._flags & (Game._FLAG_ASSETS_LOADED | Game._FLAG_SDK_INITIALIZED)) == (Game._FLAG_ASSETS_LOADED | Game._FLAG_SDK_INITIALIZED)) {
            // Vytvorit gameplay            
            this._gameplay = new Gameplay();

            // Spustit herni smycku
            Game._app.on("update", this.handleAppUpdate, this);

            if (Game.API == ePublisherAPI.ARC8 || Game.API == ePublisherAPI.PRIZES) {
                Gamee.Wrapper.gameReady();
            }
        }
    }

    /*private static readonly FRAMES_TO_SKIP = 3;

    private _framesToSkip: number = Game.FRAMES_TO_SKIP;
    private _skippedFramesDelta: number = 0;*/

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAppUpdate(dt: number): void {
        //FPS_METER.tick();

        if (!Game._paused) {
            /*if (this._framesToSkip-- == 0) {
                this._framesToSkip = Game.FRAMES_TO_SKIP;
                this._gameplay.update(dt + this._skippedFramesDelta);
                this._skippedFramesDelta = 0;
            }
            else {
                this._skippedFramesDelta += dt;
            }*/

            this._gameplay.update(dt);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleGameResize(w: number, h: number): void {
        // Nastavit FOV kamery podle aktualniho rozliseni hry
        let scale = Game._scale;

        Game._camera.camera.fov = Game.CAM_MIN_H_FOV + ((h - scale.minHeight) / (scale.maxHeight - scale.minHeight)) * (Game.CAM_MAX_H_FOV - Game.CAM_MIN_H_FOV);
    }
}



if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState !== 'visible') {
            Game.stopAllSounds();
        }
        else {
            Game.startAmbientAudio();
        }
    }, false);
}



window.addEventListener("DOMContentLoaded", () => {
    new Game();
});